export default ['Adults', 'Teen-agers', 'Women', 'Men', 'Kids'];
